export enum SCORE {
  none,
  low,
  medium,
  high,
}

enum FrustrationScoreThreshold {
  LOW = 0,
  MEDIUM = 0.25,
  HIGH = 0.7,
}

export const getFrustrationScoreAsBucket = (score?: number): SCORE | null => {
  if (score === undefined) return null;

  if (score >= FrustrationScoreThreshold.HIGH) return SCORE.high;
  if (score > FrustrationScoreThreshold.MEDIUM) return SCORE.medium;
  if (score > FrustrationScoreThreshold.LOW) return SCORE.low;

  return SCORE.none;
};

enum EngagementScoreThreshold {
  LOW = 0,
  MEDIUM = 2,
  HIGH = 7,
}

export const getEngagementScoreAsBucket = (score?: number): SCORE | null => {
  if (score === undefined) return null;

  if (score >= EngagementScoreThreshold.HIGH) return SCORE.high;
  if (score > EngagementScoreThreshold.MEDIUM) return SCORE.medium;
  if (score > EngagementScoreThreshold.LOW) return SCORE.low;

  return SCORE.none;
};
